"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5223 4H16.5V2h-9v2h.9777c-.0827 1.793-.3835 2.979-.6925 4.1119l-.0647.2365C7.365 9.644 7 10.9748 7 13v9h10v-9c0-2.0252-.365-3.3559-.7205-4.6517l-.0647-.2364c-.309-1.1329-.6098-2.319-.6925-4.1119zm-2.0019 0h-3.0408c-.086 2.0475-.4296 3.409-.7648 4.6381l-.0602.2199C9.3037 10.139 9 11.2479 9 13v7h6v-7c0-1.7521-.3037-2.8609-.6546-4.142l-.0602-.2199C13.95 7.4091 13.6064 6.0475 13.5204 4z"
  })];
};

exports.default = _default;